import { Dialog } from 'primereact/dialog';
import React from 'react';
import './VideoTutorial.scss';
import { useAccount } from '../../../contexts/account/AccountContexts';
import { useTranslation } from 'react-i18next';
import { VIDEO_TUTORIAL_URL } from '../../../constans/constans';

const VideoTutorial: React.FC = () => {
  const { showVideoTutorial, setShowVideoTutorial } = useAccount();
  const { t } = useTranslation();

  const handleClose = () => {
    setShowVideoTutorial(false);
  };

  return (
    <Dialog
      visible={showVideoTutorial}
      header={t('videoTutorial')}
      style={{ width: '90vw', maxWidth: '700px' }}
      onHide={handleClose}
      closable={true}
      className="dialog-box dialog-box--video"
    >
      <div className="video-tutorial__wrapper" style={{ position: 'relative', paddingTop: '56.25%' }}>
        <iframe
          src={`${VIDEO_TUTORIAL_URL}?rel=0&showinfo=0`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope"
          allowFullScreen
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 'none',
          }}
        />
      </div>
    </Dialog>
  );
};

export default VideoTutorial;
